import type { FilterConsistencyState } from '../engine/filterGroupConsistency';

// Filter state is shared across pages so selections carry over as the user
// navigates. Pages that must stay isolated (reports, the AI chart preview)
// opt out with `persistScope={false}`; pages that must not share a filter
// group with a sibling page key that group by page id instead.
let sharedFilterState: FilterConsistencyState | null = null;

export const getSharedFilterState = (): FilterConsistencyState | null =>
  sharedFilterState;

export const setSharedFilterState = (next: FilterConsistencyState): void => {
  sharedFilterState = next;
};

/**Test-only: drop the shared state */
export const __resetSharedFilterStateForTests = (): void => {
  sharedFilterState = null;
};
